import { render, staticRenderFns } from "./FarmHeader.vue?vue&type=template&id=38c2fbc7&scoped=true&"
import script from "./FarmHeader.vue?vue&type=script&lang=ts&"
export * from "./FarmHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FarmHeader.vue?vue&type=style&index=0&id=38c2fbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2fbc7",
  null
  
)

export default component.exports